import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export interface ReverseTransferResult {
  success: boolean;
  amount: number;
  debit_id: string;
  credit_id: string;
  origin_account_id: string;
  destination_account_id: string;
  deleted_ids: string[];
  reset_ids: string[];
  fee_expense_ids: string[];
  fee_total: number;
}

export const useReverseTransfer = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (bankTransactionId: string): Promise<ReverseTransferResult> => {
      const { data, error } = await supabase.rpc('reverse_internal_transfer_atomic', {
        p_bank_transaction_id: bankTransactionId,
      });

      if (error) throw error;
      return data as unknown as ReverseTransferResult;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['financial-accounts'] });
      queryClient.invalidateQueries({ queryKey: ['account-transactions'] });
      queryClient.invalidateQueries({ queryKey: ['bank-transactions'] });
      queryClient.invalidateQueries({ queryKey: ['system-payments'] });
      queryClient.invalidateQueries({ queryKey: ['expenses'] });
      queryClient.invalidateQueries({ queryKey: ['dre-data-hierarchical'] });
      queryClient.invalidateQueries({ queryKey: ['dre-indicators'] });
      queryClient.invalidateQueries({ queryKey: ['cash-flow'] });
      queryClient.invalidateQueries({ queryKey: ['account-balance-check'] });
      toast({ title: 'Transferência estornada' });
    },
    onError: (error: { message?: string }) => {
      toast({
        title: 'Erro ao estornar transferência',
        description: error?.message ?? 'Erro desconhecido',
        variant: 'destructive',
      });
    },
  });
};
